module.exports = __webpack_public_path__ + "static/media/5.be37ada6.jpg";